import { formatters } from '@cbgms/base/utils/datetime'
import moment from 'moment'

export const convertISOToLocalDate = (date: string): string => {
  return formatters.date.toUserFormat(moment(date).local())
}

export const supportedImageFileTypes = ['jpg', 'jpeg', 'png', 'svg']

export const parseBoolOrNull = (value: string | null | undefined): boolean | null => {
  if (value === null || value === undefined || value.trim() === '') {
    return null
  }

  const lower = value.toLowerCase()
  if (lower === 'true') return true
  if (lower === 'false') return false

  return null
}

export const adhocAttachmentWholesalerUUID = 'product-warranty-claim'
